<template>
    <v-footer app class="text-caption py-0" height="18px">
        <v-row no-gutters>
            <v-col class="text-center footer-text">
                Made with <v-icon color="error" x-small>mdi-heart</v-icon> in
                Philadelphia - Venue Management System
                {{ $store.state.appVersion }}
            </v-col>
            <span class="px-2 footer-text">{{ currentDateTime }}</span>
            <span v-if="isUserAuthenticated">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-icon
                            small
                            color="accent"
                            class="px-1"
                            v-on="on"
                            @click="onJobsClick"
                            >{{ icons.jobs }}</v-icon
                        >
                    </template>
                    <span>Show jobs status</span>
                </v-tooltip>
            </span>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-icon
                        small
                        color="accent"
                        class="px-1"
                        v-on="on"
                        @click="onDarkModeClick"
                        >{{ icons.darkMode }}</v-icon
                    >
                </template>
                <span>Toggle dark mode</span>
            </v-tooltip>
        </v-row>
    </v-footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AppFooter',
    data() {
        return {
            timer: null,
            currentTime: null
        };
    },
    computed: {
        ...mapGetters('authUser', ['isUserAuthenticated']),
        currentDateTime() {
            const now = this.currentTime || new Date();
            return `${now.toLocaleDateString()}, ${now.toLocaleTimeString()}`;
        }
    },
    mounted() {
        this.timer = setInterval(() => {
            this.currentTime = new Date();
        }, 2000);
    },
    beforeDestroyed() {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        onDarkModeClick() {
            this.$emit('switch-mode');
        },
        onJobsClick() {
            this.$emit('jobs');
        }
    }
};
</script>

<style lang="scss">
.v-footer {
    border-top: 1px solid #ccc !important;
    .footer-text {
        opacity: 0.7;
    }
}
</style>
